import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from '../../utils/classNames';

export type LoadingSpinnerProps = Omit<FontAwesomeIconProps, 'icon'>;

function LoadingSpinner({ className, ...props }: LoadingSpinnerProps) {
    return (
        <FontAwesomeIcon
            icon={faSpinner}
            className={classNames('animate-spin', className)}
            {...props}
        />
    );
}

export default LoadingSpinner;
